<template>
  <div class="ticactoe" style="width: 100%;">
    <div class="user_skills" style="margin-top:20px;">
      <el-table :data="filterTableData" style="width: 100%;color: white;"
                :header-cell-style="{background:'#eef1f6',color:'#606266'}">
        <el-table-column label="序号" prop="order" width="80"/>
        <el-table-column label="识别名称" prop="rule_name" width="200"/>
        <el-table-column label="识别描述" prop="rule_desc" width="200" />
        <el-table-column label="操作" align="center" width="300">
          <template #default="scope">
            <div class="icon-container">
              <button class="custom-btn btn-9" @click="handleShow(scope.$index, scope.row)"><span>演示</span></button>
              <button v-show="!scope.row.isAdded" class="custom-btn btn-9" @click="handleAdd(scope.$index, scope.row)"><span>添加</span></button>
              <button v-show="scope.row.isAdded" class="custom-btn btn-9" @click="handleRemove(scope.$index, scope.row)"><span>移除</span></button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <el-pagination v-if="allRoomSettings.length > pageSize" :background="true" layout="prev, pager, next" :page-count="pageCount" @current-change="changePage" />
    </div>

    <el-dialog class="dialog-content" v-model="dialogFormVisible" :title="dialogTitle" style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="复制">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="活动">
          <el-select v-model="form.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动时间1111">
          <el-col :span="11">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="即时配送">
          <el-switch v-model="form.delivery"></el-switch>
        </el-form-item>
        <el-form-item label="活动性质">
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
            <el-checkbox label="地推活动" name="type"></el-checkbox>
            <el-checkbox label="线下主题活动" name="type"></el-checkbox>
            <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="特殊资源">
          <el-radio-group v-model="form.resource">
            <el-radio label="线上品牌商赞助"></el-radio>
            <el-radio label="线下场地免费"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动形式">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="SaveFormData(itemSettings)">
          保存
        </el-button>
      </span>
      </template>
    </el-dialog>


  </div>
</template>

<script>
// const { postRemoteData } = require('@/api/reqWx.js');
import axios from "axios";
import {ElMessage} from "element-plus";

export default {
  name: "TictactoeShop",
  // 1.根据规则发 2.根据时间发 3.多少条触发发 4.监控开始结束时间
  data() {
    return {
      minutesPickers: Array.from(Array(60).keys()),
      timeoutPickers: Array.from({length: (5000 / 500) + 1}, (_, index) => index * 500),
      timerPickers: Array.from(Array(10).keys()).map(num => num + 1),
      tasks: [
        {
          value: '#E63415',
          label: 'red',
        },
        {
          value: '#FF6600',
          label: 'orange',
        },
        {
          value: '#FFDE0A',
          label: 'yellow',
        },
        {
          value: '#1EC79D',
          label: 'green',
        },
        {
          value: '#14CCCC',
          label: 'cyan',
        },
        {
          value: '#4167F0',
          label: 'blue',
        },
        {
          value: '#6222C9',
          label: 'purple',
        },
      ],
      allRoomSettings: [
        {
          "order": 1,
          "rule_name": "数字相加",
          "rule_desc": "自动识别数字进行相加",
          "user_people": 60
        }
      ],
      roomListSelects: [],
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      dialogFormVisible: false,
      formLabelWidth: "150px",
      totalPageCount: 15,
      totalCount: 15,
      isAllData: [
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        },
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        },
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        },
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        }
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      baseWsUrl: "ws://127.0.0.1:5000",
      baseUrl: "http://127.0.0.1:5000",
      websocket: null,
      connected: false,
      isLoin: false,
      currentLoginWx: null,
      fullLoginWxs: null,
      fullRoomList: null,
      isExpired: false,
      secret: "123456",
      dialogTitle: "演示内容"
    }
  },
  async mounted() {
    await this.check_backend()
    await this.LoadRoomList()
  },
  beforeUnmount() {
  },
  // 3. 在 methods 中定义函数
  methods: {
    async handleLogin() {

    },
    async LoadRoomList() {
      console.log("currentInfo", this.currentInfo)
      this.allRoomSettings = [
        {
          "order": 1,
          "rule_name": "数字相加",
          "rule_desc": "自动识别数字进行相加",
          "user_people": 60,
          "gif": "http://xxx",
          "isAdded": true
        },
        {
          "order": 2,
          "rule_name": "提取数字",
          "rule_desc": "自动识别数字提取",
          "user_people": 299,
          "gif": "http://xxx",
          "isAdded": false
        }
      ]
      console.log(this.allRoomSettings)
      // 整理数据
      for(let i=0;i<this.allRoomSettings.length;i++) {
        if(this.selfRules.indexOf(this.allRoomSettings[i]["rule_name"]) !== -1) {
          this.allRoomSettings[i]["isAdded"] = true
        }
      }
      // 排序
      for(let i=0;i<this.allRoomSettings.length;i++) {
        this.allRoomSettings[i]["order"] = i + 1 + ""
      }
    },
    async check_backend() {
      let url = this.baseUrl + "/get_login_wx"
      let resData = await this.postAxios(url, {})
      if(resData) {
        console.log("后台已正常启动...")
        this.fullLoginWxs = resData["data"]
        this.connected = true
        for(let wxid in this.fullLoginWxs) {
          console.log("this.fullLoginWxs", this.fullLoginWxs[wxid]["expire_time"])
          // eslint-disable-next-line no-prototype-builtins
          if(this.fullLoginWxs[wxid].hasOwnProperty("expire_time")) {
            this.$store.commit("setExpireTime", this.fullLoginWxs[wxid]["expire_time"])
          }
          // eslint-disable-next-line no-prototype-builtins
          if(this.fullLoginWxs.hasOwnProperty(wxid)) {
            this.currentLoginWx = this.fullLoginWxs[wxid]
            this.$store.commit("setAvatarUrl", this.currentLoginWx["avatar_url"])
            console.log("this.currentLoginWx", this.currentLoginWx)
            this.isLoin = true
            this.$store.commit('setCurrentInfo', this.currentLoginWx);
            return true
          }
        }

      } else {
        this.connected = false
        return false
      }
    },
    // 查询当前wxid的已添加的任务列表
    async findSelfRules() {
      this.$store.commit('setSelfRules', ["数字相加"]);
    },
    handleShow(index, data) {
      console.log("raw data", data)
      this.dialogTitle = data["rule_name"] + "扣排演示"
      this.dialogFormVisible = true
    },
    handleAdd(index, data) {
      console.log("index", index)
      console.log("data", data)
      this.allRoomSettings[index]["isAdded"] = true
      let rules = this.selfRules
      rules.push(this.allRoomSettings[index]["rule_name"])
      rules = this.selfRules.filter((item, index) => this.selfRules.indexOf(item) === index)
      this.updateRules(rules);
    },
    handleRemove(index) {
      this.allRoomSettings[index]["isAdded"] = false
      let rules = this.selfRules
      rules = rules.filter(item => item.toString() !== this.allRoomSettings[index]["rule_name"].toString())
      this.updateRules(rules);
      console.log(this.selfRules)
    },
    updateGlobalVariable(newData) {
      this.$store.commit('setGlobalVariable', newData);
    },
    async handleActive() {

    },
    async postAxios(url, data) {
      try {
        let res = await axios.post(url, data)
        if(res.status === 200) {
          console.log(res["data"])
          if(res["data"].code === 0) {
            return res["data"]
          } else {
            ElMessage.warning(res["data"].msg)
          }
        }
      } catch (e) {
        ElMessage.warning("网络异常!")
        this.connected = false
      }
    },
    sendGlobalMessage(title, content, formattedDate) {
      this.globalMessage.unshift({ id: this.globalMessage.length + 1, title: title, time: formattedDate, content: content })
      this.$store.state.unreadNum = this.$store.state.unreadNum + 1
      // 先检查是否超过了20条消息
      if (this.globalMessage.length >= 20) {
        // 如果超过了20条，删除最后一条消息
        this.globalMessage.splice(-1, 1);
      }
    },
    handleRefresh() {
      window.location.reload()
    },
    async postSettings() {
    },
    handlePageChange(page) {
      if(!this.isAllData) {
        this.currentData = this.currentAllData.slice((page - 1) * this.pageSize, (page) * this.pageSize)
      } else {
        this.pageCount = page
        this.getTaskOrder()
      }
    },
    handleEdit(index, row) {
      console.log(index, row)
      this.dialogFormVisible = true
      this.itemSettings = row
    },
    changePage(currentPage) {
      // 在这里处理分页切换逻辑，currentPage 即为当前页码
      console.log('当前页码:', currentPage);
      this.currentPage = currentPage
    },
    async handleSwitchChange(row, value) {
      row.isOpen = value;
      localStorage.setItem(row["roomId"] + "+taskSettings", JSON.stringify(row))
      await this.postSettings()
    },
    updateRules(newRules) {
      this.$store.commit('setSelfRules', newRules);
    },
    updateTotal() {
      this.total = this.isAllData.length;
    },
    calculateRemainingSeconds(targetMinute) {
      // 获取当前时间
      const now = new Date();
      let setTime = new Date();

      // 获取当前小时和分钟
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      setTime.setHours(currentHour, targetMinute, 0, 0)
      if(currentMinute >= targetMinute) {
        setTime = new Date(setTime.getTime() + 3600 * 1000)
      } else {
        setTime.setHours(currentHour, targetMinute, 0, 0)
      }
      return setTime.getTime() - now.getTime()
    }
  },
  // 4. 在 computed 中定义计算属性
  computed: {
    // 使用全局变量
    globalVariable() {
      return this.$store.state.globalVariable;
    },
    currentInfo() {
      return this.$store.state.currentInfo;
    },
    selfRules() {
      return this.$store.state.selfRules;
    },
    // 修改 filterTableData 以根据分页信息截取数据
    filterTableData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.allRoomSettings.slice(startIndex, endIndex);
    },
    pageCount() {
      return parseInt(this.allRoomSettings.length / this.pageSize) + 1
    },
    globalMessage() {
      return this.$store.state.globalMessage;
    },
    unreadNum() {
      return this.$store.state.unreadNum;
    },
    currentPageData() {
      // 用于渲染当前页的数据
      return this.filterTableData;
    },
  },
}
</script>


<style lang="scss" scoped>
.center-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60%; /* 使容器占据整个视口的高度 */
}

.instruction-text {
  color: white;
  font-size: 20px;
  margin: 10px 0; /* 设置上下间隙，根据需要调整数值 */
}

/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  background-color: transparent !important;
  border: 0; //去除表格
}

::v-deep .el-pagination {
  background-color: transparent !important;
  border: 0; //去除表格
}
/*去除底边框*/
::v-deep.el-table td.el-table__cell {
  border: 0;
}
::v-deep.el-table th.el-table__cell.is-leaf {
  border: 0;
}
/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
  display: none;
  height: 0;
}
::v-deep .el-table__inner-wrapper::before {
  height: 0;
}

.dynamic-width-input {
  width: 300px; /* 设置默认较短的宽度 */
  min-width: 100px; /* 设置最小宽度 */
  max-width: 500px; /* 设置最大宽度 */
}


// 分页样式改造
::v-deep .el-pagination.is-background .btn-prev{
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}
::v-deep .el-pagination.is-background .btn-next{
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}
::v-deep .el-pagination.is-background .el-pager li{
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #cc66ff;
}
::v-deep .el-pagination__editor.el-input .el-input__inner{
  background: transparent;
  //border: 1px solid #295a85;
  color: #fff;
}
::v-deep .el-pagination__total, ::v-deep .el-pagination__jump{
  color: #fff;
}

.dialog-content {
  background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.fade-enter-to, .fade-leave {
  opacity: 1;
}
.icon-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.icon-container-left {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
}

.custom-btn {
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 10px;
  //margin: 0 10px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1),
  4px 4px 5px 0px rgba(0,0,0,.1);
  outline: none;

}

.btn-9 {
  border: none;
  transition: all 0.3s ease;
  overflow: hidden;

  &:after {
    position: absolute;
    content: " ";
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1fd1f9;
    background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
    transition: all 0.3s ease;
  }
  &:hover {
    background: transparent;
    box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255,255,255,.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
    color: #fff;
  }
  &:hover:after {
    -webkit-transform: scale(2) rotate(180deg);
    transform: scale(2) rotate(180deg);
    box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255,255,255,.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
  }
}

.btn-12 {
  position: relative;
  right: 20px;
  bottom: 20px;
  border:none;
  box-shadow: none;
  width: 130px;
  height: 40px;
  line-height: 42px;
  -webkit-perspective: 230px;
  perspective: 230px;

  & span {
    background: rgb(0,172,238);
    background: linear-gradient(0deg, rgba(0,172,238,1) 0%, rgba(2,126,251,1) 100%);
    display: block;
    position: absolute;
    width: 130px;
    height: 40px;
    box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
    7px 7px 20px 0px rgba(0,0,0,.1),
    4px 4px 5px 0px rgba(0,0,0,.1);
    border-radius: 5px;
    margin:0;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  & span:nth-child(1) {
    box-shadow:
        -7px -7px 20px 0px #fff9,
        -4px -4px 5px 0px #fff9,
        7px 7px 20px 0px #0002,
        4px 4px 5px 0px #0001;
    -webkit-transform: rotateX(90deg);
    -moz-transform: rotateX(90deg);
    transform: rotateX(90deg);
    -webkit-transform-origin: 50% 50% -20px;
    -moz-transform-origin: 50% 50% -20px;
    transform-origin: 50% 50% -20px;
  }
  & span:nth-child(2) {
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: 50% 50% -20px;
    -moz-transform-origin: 50% 50% -20px;
    transform-origin: 50% 50% -20px;
  }
  &:hover span:nth-child(1) {
    box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
    7px 7px 20px 0px rgba(0,0,0,.1),
    4px 4px 5px 0px rgba(0,0,0,.1);
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  &:hover span:nth-child(2) {
    box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
    7px 7px 20px 0px rgba(0,0,0,.1),
    4px 4px 5px 0px rgba(0,0,0,.1);
    color: transparent;
    -webkit-transform: rotateX(-90deg);
    -moz-transform: rotateX(-90deg);
    transform: rotateX(-90deg);
  }
}

</style>

